import { Mail, Share2, Grid } from "lucide-react";
import logo from "../images/amiLogo.jpg";

function Footer() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

        .ft-root {
          font-family: 'DM Sans', sans-serif;
          background: #f0f8ff;
          color: #0c1a2e;
          position: relative;
          z-index: 20;
          border-top: 2px solid #bae6fd;
        }

        /* CTA Band */
        .ft-cta {
          background: linear-gradient(90deg, #0284c7 0%, #0ea5e9 50%, #38bdf8 100%);
          padding: 26px 48px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          flex-wrap: wrap;
        }
        .ft-cta h3 {
          font-family: 'Syne', sans-serif;
          font-size: 18px;
          font-weight: 800;
          color: #fff;
          letter-spacing: -.3px;
        }
        .ft-cta p { font-size: 12.5px; color: rgba(255,255,255,.75); margin-top: 3px; }
        .ft-cta-btn {
          background: #fff;
          color: #0284c7;
          border: none;
          border-radius: 24px;
          padding: 10px 24px;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
          font-family: 'DM Sans', sans-serif;
          transition: background .2s, transform .2s, box-shadow .2s;
          white-space: nowrap;
          box-shadow: 0 4px 16px rgba(0,0,0,.12);
        }
        .ft-cta-btn:hover {
          background: #e0f2fe;
          transform: translateY(-1px);
          box-shadow: 0 6px 24px rgba(0,0,0,.15);
        }

        /* Main grid */
        .ft-grid {
          padding: 44px 48px 28px;
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1.5fr;
          gap: 36px;
          border-bottom: 1px solid #dbeeff;
        }

        /* Brand */
        .ft-logo-img {
          height: 36px; object-fit: contain;
          border-radius: 6px; margin-bottom: 14px;
        }
        .ft-tagline {
          font-size: 11px;
          color: #5a9ab5;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          line-height: 1.75;
          margin-bottom: 18px;
          max-width: 190px;
        }
        .ft-badge {
          display: inline-flex; align-items: center; gap: 6px;
          background: #e0f2fe;
          border: 1px solid #bae6fd;
          border-radius: 20px;
          padding: 5px 12px;
          font-size: 9.5px; font-weight: 700;
          letter-spacing: 1.2px; text-transform: uppercase;
          color: #0284c7;
        }
        .ft-badge-dot {
          width: 6px; height: 6px; border-radius: 50%;
          background: #0ea5e9;
          animation: ftbp 2s ease-in-out infinite;
        }
        @keyframes ftbp {
          0%,100%{opacity:1;transform:scale(1)}
          50%{opacity:.3;transform:scale(1.7)}
        }

        /* Link cols */
        .ft-col-head {
          font-size: 9px; font-weight: 700;
          letter-spacing: 2.5px; text-transform: uppercase;
          color: #7dd3fc; margin-bottom: 16px;
        }
        .ft-links { list-style: none; }
        .ft-links li {
          font-size: 13px; color: #4a7a9a;
          margin-bottom: 11px; cursor: pointer;
          display: flex; align-items: center; gap: 8px;
          transition: color .2s;
        }
        .ft-links li::before {
          content: ''; width: 4px; height: 4px; border-radius: 50%;
          background: #bae6fd; flex-shrink: 0; transition: background .2s;
        }
        .ft-links li:hover { color: #0284c7; }
        .ft-links li:hover::before { background: #0ea5e9; }

        /* Social */
        .ft-social { display: flex; gap: 9px; margin-bottom: 18px; }
        .ft-soc-btn {
          width: 36px; height: 36px; border-radius: 9px;
          background: #fff; border: 1px solid #bae6fd;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; color: #5a9ab5;
          transition: background .2s, border-color .2s, color .2s, transform .2s;
        }
        .ft-soc-btn:hover {
          background: #e0f2fe; border-color: #38bdf8;
          color: #0284c7; transform: translateY(-2px);
        }

        /* Newsletter */
        .ft-nl-label {
          font-size: 9.5px; font-weight: 700;
          letter-spacing: 1.5px; text-transform: uppercase;
          color: #7dd3fc; margin-bottom: 8px;
        }
        .ft-nl-row {
          display: flex;
          border: 1px solid #bae6fd;
          border-radius: 8px; overflow: hidden;
          background: #fff;
        }
        .ft-nl-row input {
          background: transparent; border: none;
          padding: 9px 12px; font-size: 12px;
          color: #0c1a2e; font-family: 'DM Sans', sans-serif;
          outline: none; flex: 1; min-width: 0;
        }
        .ft-nl-row input::placeholder { color: #bae6fd; }
        .ft-nl-row button {
          background: linear-gradient(90deg,#0284c7,#38bdf8);
          border: none; padding: 9px 14px;
          color: #fff; font-size: 12px; font-weight: 700;
          cursor: pointer; font-family: 'DM Sans', sans-serif;
          transition: opacity .2s; white-space: nowrap;
        }
        .ft-nl-row button:hover { opacity: .9; }

        /* Bottom bar */
        .ft-bottom {
          padding: 16px 48px;
          display: flex; align-items: center;
          justify-content: space-between; flex-wrap: wrap; gap: 10px;
          background: #e0f2fe;
        }
        .ft-copy { font-size: 11px; color: #5a9ab5; }
        .ft-status {
          display: flex; align-items: center; gap: 7px;
          font-size: 11px; color: #5a9ab5;
        }
        .ft-sdot {
          width: 6px; height: 6px; border-radius: 50%;
          background: #0ea5e9; animation: ftbp 2s ease-in-out infinite;
        }
        .ft-legal { display: flex; gap: 18px; }
        .ft-legal a {
          font-size: 11px; color: #5a9ab5; text-decoration: none;
          transition: color .2s;
        }
        .ft-legal a:hover { color: #0284c7; }

        @media(max-width:900px){
          .ft-grid{ grid-template-columns:1fr 1fr; padding:28px 24px; }
          .ft-cta { padding:22px 24px; }
          .ft-bottom{ padding:14px 24px; flex-direction:column; align-items:flex-start; }
        }
        @media(max-width:560px){
          .ft-grid{ grid-template-columns:1fr; }
        }
      `}</style>

      <footer className="ft-root">

        {/* CTA band */}
        <div className="ft-cta">
          <div>
            <h3>Ready to deploy sovereign AI?</h3>
            <p>Join 40+ nations running AMI Paradigm on critical infrastructure.</p>
          </div>
          <button className="ft-cta-btn">Start a conversation →</button>
        </div>

        {/* Main columns */}
        <div className="ft-grid">

          {/* Brand */}
          <div>
            <img src={logo} alt="AMI Paradigm" className="ft-logo-img"/>
            <p className="ft-tagline">Engineering the cognitive<br/>backbone of resilient nations.</p>
            <div className="ft-badge">
              <div className="ft-badge-dot"/>
              All systems operational
            </div>
          </div>

          {/* Systems */}
          <div>
            <p className="ft-col-head">Systems</p>
            <ul className="ft-links">
              <li>Sovereign</li>
              <li>Industrial</li>
              <li>Digital</li>
              <li>Edge OS</li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <p className="ft-col-head">Legal</p>
            <ul className="ft-links">
              <li>Privacy Policy</li>
              <li>Terms of Service</li>
              <li>Security</li>
              <li>Cookies</li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <p className="ft-col-head">Connect</p>
            <div className="ft-social">
              <div className="ft-soc-btn"><Mail size={15}/></div>
              <div className="ft-soc-btn"><Share2 size={15}/></div>
              <div className="ft-soc-btn"><Grid size={15}/></div>
            </div>
            <p className="ft-nl-label">Stay updated</p>
            <div className="ft-nl-row">
              <input type="email" placeholder="your@email.com"/>
              <button type="button">Subscribe</button>
            </div>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="ft-bottom">
          <p className="ft-copy">© 2024 AMI Paradigm. Sovereign AI & Infrastructure.</p>
          <div className="ft-status">
            <div className="ft-sdot"/>
            All systems operational
          </div>
          <div className="ft-legal">
            <a href="#">Privacy</a>
            <a href="#">Terms</a>
            <a href="#">Cookies</a>
          </div>
        </div>

      </footer>
    </>
  );
}

export default Footer;